var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 662,
    viewBox: "0 0 1920 662",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1163)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 707,
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_1_1163)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1765.5,
    cy: 621.5,
    r: 201.5,
    fill: "#9B0303"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter1_f_1_1163)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 172,
    r: 248,
    fill: "#9B0303"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_1163",
    x: 1369.9,
    y: 225.9,
    width: 791.2,
    height: 791.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 97.05,
    result: "effect1_foregroundBlur_1_1163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_1163",
    x: -357.1,
    y: -270.1,
    width: 884.2,
    height: 884.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 97.05,
    result: "effect1_foregroundBlur_1_1163"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 662,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgblack);
export default __webpack_public_path__ + "static/media/bgblack.ad5ba5714ea7f5e7f4de817643ebaa18.svg";
export { ForwardRef as ReactComponent };